import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseService } from 'src/app/system-common/services/base.service';
import { AgentRelationService } from '../services/agentRelation.service';
import { AgentRelationSearchHandler } from './agent-relation-search.handler';

@Component({
  selector: 'sym-agent-relation-search',
  templateUrl: './agent-relation-search.component.html',
  styleUrls: ['./agent-relation-search.component.scss'],
})
export class AgentRelationSearchComponent extends AgentRelationSearchHandler {
  constructor(
    public service: AgentRelationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
